import { updateURL } from 'components/Booking-new/utils/helpers';
import getAllSteps from './getAllSteps';

const inRange = (value, max, min) => {
  return value > min && value < max;
};

// prevent user to visit next steps if the previous were not filled in
// TODO: create more complex solution to check steps individualy because not every step has `userData`
const isParamStepPossible = (paramStepIndex, allSteps, userData) => {
  if (paramStepIndex === 0) return true;

  const allPossibleSteps = [...allSteps];
  const previousSteps = allPossibleSteps.slice(0, paramStepIndex);
  const previousStepsCount = previousSteps?.length;
  const prevStepsUserData = previousSteps.filter(step => userData?.[step?.type]);
  const isCurrentStepPossible = previousStepsCount === prevStepsUserData?.length;
  return isCurrentStepPossible;
};

const setCurrentStep = (paramValue, state = null, paramKey) => {
  if (paramValue === null || state === null) return state || {};

  const value = paramValue - 1; // change to array index
  const allSteps = getAllSteps(state);
  const availableStepsCount = allSteps.length - 1; // user shouldn't see last step
  const userData = state.userData;
  const isCorrectValue = inRange(value, availableStepsCount, 0) && isParamStepPossible(value, allSteps, userData);

  if (!isCorrectValue) updateURL(paramKey, 1);

  return {
    ...state,
    activeStep: isCorrectValue ? value : 0,
  };
};

export default setCurrentStep;
